module.exports = __webpack_public_path__ + "static/img/logo.b7b7e9df.svg";